
import { useQuery } from '@tanstack/react-query';
import { useStaticFilterName, useStaticFilterNames } from '@/hooks/image-generator/static-filters/hooks';

/**
 * Hook to fetch a filter name by ID from static data
 */
export const useFilterName = (id: string | undefined) => {
  return useStaticFilterName(id);
};

/**
 * Hook to fetch multiple filter names by IDs from static data
 */
export const useFilterNames = (ids: string[] | undefined) => {
  return useStaticFilterNames(ids);
};
